import { request } from '@lib/request';
import { isEmpty } from 'lodash';

export function getAccountSummary() {
    return request({
        method: 'get',
        url: '/api/balance-asset/account-summary',
    });
}

export function fetchTransactionRecords(payload) {
    return request({
        method: 'get',
        url: `/api/balance-asset/transaction-records?startDate=${payload.startDate}&endDate=${payload.endDate}&currency=${payload.currency}`
    })
}

export function fetchDepositWithdrawalRecords(payload) {
    return request({
        method: 'get',
        url: `/api/balance-asset/deposit-withdrawal-records?startDate=${payload.startDate}&endDate=${payload.endDate}&currency=${payload.currency}`
    })
}

export function withdrawal(payload) {
    return request({
        method: 'post',
        url: '/api/balance-asset/withdrawal',
        data: payload
    })
}

export function fetchFunderContributions(payload) {
    const { currencies, isRemitted } = payload;
    let currenciesStr = '';
    if (!isEmpty(currencies)) {
        currencies.forEach(currency => currenciesStr = currenciesStr.concat(`&currencies=${currency}`));
    }
    return request({
        method: 'get',
        url: `/api/balance-asset/contributions?isRemitted=${isRemitted}${currenciesStr}`
    });
}

export function fetchAwaitingRepaymentRecords() {
    return request({
        method: 'get',
        url: '/api/balance-asset/awaiting-repayment'
    });
}

export function fetchPastAuctions(payload) {
    const { startDate, endDate } = payload;
    return request({
        method: 'get',
        url: `/api/balance-asset/past-auctions?startDate=${startDate}&endDate=${endDate}`
    });
}